import jQuery from 'jquery'
import autosize from 'autosize';

window.$ = window.jQuery = jQuery;
window.autosize = autosize;

$(function(){
  autosize($('textarea'));
});